


























import { Component, Prop, Vue } from 'vue-property-decorator';
import {ProjectBudgetViewModel} from '@/services/api/nswag/stapiclient_generated';
import {UserStore} from '@/store/user-module';
import StProgress from '@/components/basic/StProgress.vue';

@Component({
  components: {StProgress},
})
export default class StNotification extends Vue {
  @Prop() item: any;
  @Prop() closeFunc: any;

  undoDeletion() {
    this.item.data.undoFunc();
    this.closeFunc();
  }

  get budgetModel(): ProjectBudgetViewModel | null {
    if (this.item.data.isBudget)
    {
      return this.item.data.budget as ProjectBudgetViewModel;
    }

    return null;
  }

  get currency() {
    return UserStore.userSettings.currency;
  }
}
